import { FilterTypes } from '@carboledger/ui';
import { customerFilter, materialFilter } from '@/config/filterDefinitions';
import { buildStatusFilterOptions } from './orderStatus';

// Filter definitions for <OrdersPage>; each field is one PendingOrderFilters accepts.
export const ORDER_FILTERS = Object.freeze({
  status: 'status',
  materialId: 'materialId',
  customerAccountId: 'customerAccountId',
});

export const buildOrderFilterDefinitions = (t, { materialOptions, customerOptions } = {}) => [
  {
    field: ORDER_FILTERS.status,
    label: t('FIELD_STATUS'),
    type: FilterTypes.checkbox,
    options: buildStatusFilterOptions(t),
  },
  ...materialFilter(t, ORDER_FILTERS.materialId, materialOptions),
  ...customerFilter(t, ORDER_FILTERS.customerAccountId, customerOptions),
];
